import React from 'react';
import { FadeIn } from './FadeIn';
import { trackPixel } from '../lib/pixel';
import { ArrowRightIcon, ShieldCheckIcon, LockIcon, ZapIcon, CheckIcon, SparklesIcon, MailIcon } from 'lucide-react';
export function Offer() {
  const includes = [{
    text: '6 Tomos principales (360 páginas de técnica pura)',
    hot: true
  }, {
    text: 'Bono 1 — Guía de Proveedores Latinoamérica',
    hot: false
  }, {
    text: 'Bono 2 — Checklist y Sistema de Inventario',
    hot: false
  }, {
    text: 'Bono 3 — 230 Etiquetas Vintage Imprimibles',
    hot: true
  }, {
    text: 'Bono 4 — 40 Paletas de Color con Swatches',
    hot: false
  }, {
    text: 'Bono 5 — Masterclass Redes Sociales para Craft',
    hot: true
  }, {
    text: 'Plantillas milimétricas imprimibles',
    hot: false
  }, {
    text: 'Diagramas técnicos en alta resolución',
    hot: false
  }, {
    text: 'Fórmula de precio justo incluida',
    hot: false
  }, {
    text: 'Acceso permanente · Sin suscripción',
    hot: false
  }];
  return <section id="oferta" className="py-16 sm:py-24 px-5 bg-brand-ink relative overflow-hidden" data-id="element-135">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#b8894f08_1px,transparent_1px),linear-gradient(to_bottom,#b8894f08_1px,transparent_1px)] bg-[size:3rem_3rem] pointer-events-none" data-id="element-136" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-brand-gold/8 blur-[120px] rounded-full pointer-events-none" data-id="element-137" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-138">
        <FadeIn className="text-center mb-12" data-id="element-139">
          <span className="inline-flex items-center gap-2 bg-brand-gold/20 text-brand-gold font-bold text-xs uppercase tracking-widest px-4 py-2 rounded-full border border-brand-gold/30 mb-6" data-id="element-140">
            <ZapIcon className="w-3.5 h-3.5" data-id="element-141" />
            Oferta de lanzamiento — precio irrepetible
          </span>
          <h2 className="text-4xl sm:text-6xl font-black text-white mt-2 mb-4" data-id="element-142">
            Todo el bundle.
            <br data-id="element-143" />
            <span className="text-brand-gold" data-id="element-144">Un solo pago.</span>
          </h2>
          <p className="text-white/60 text-lg sm:text-xl" data-id="element-145">
            Sin suscripción. Sin letra chica. Sin trucos.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-146">
          <div className="bg-brand-paper border border-brand-gold/30 rounded-3xl p-6 sm:p-12 shadow-[0_0_80px_rgba(184,137,79,0.15)]" data-id="element-147">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-10" data-id="element-148">
              {/* Left: what's included */}
              <div className="flex-1" data-id="element-149">
                <h3 className="text-brand-ink font-black text-xl mb-6" data-id="element-150">
                  Todo lo que recibís:
                </h3>
                <ul className="space-y-3" data-id="element-151">
                  {includes.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-152">
                      <div className={`w-5 h-5 rounded-full flex items-center justify-center shrink-0 ${item.hot ? 'bg-brand-gold' : 'bg-brand-sage/30'}`} data-id="element-153">
                        <CheckIcon className={`w-3 h-3 ${item.hot ? 'text-white' : 'text-brand-sage'}`} data-id="element-154" />
                      </div>
                      <span className={`text-sm ${item.hot ? 'text-brand-ink font-semibold' : 'text-brand-muted'}`} data-id="element-155">
                        {item.text}
                      </span>
                      {item.hot && <span className="bg-brand-gold/15 text-brand-gold text-xs font-bold px-2 py-0.5 rounded-full border border-brand-gold/20" data-id="element-156">
                          ★
                        </span>}
                    </li>)}
                </ul>
              </div>

              {/* Right: pricing */}
              <div className="lg:w-72 flex flex-col items-center justify-center border-t lg:border-t-0 lg:border-l border-brand-line pt-8 lg:pt-0 lg:pl-10 text-center" data-id="element-157">
                <p className="text-brand-muted text-sm mb-1" data-id="element-158">
                  Valor real del bundle
                </p>
                <p className="text-brand-muted line-through text-2xl font-display mb-4" data-id="element-159">
                  $256 USD
                </p>

                <div className="mb-2" data-id="element-160">
                  <span className="text-brand-muted text-sm" data-id="element-161">Precio hoy</span>
                </div>
                <div className="text-6xl font-black text-brand-gold leading-none mb-1" data-id="element-162">
                  $19.990
                </div>
                <div className="text-brand-muted text-sm mb-8" data-id="element-163">Pago único</div>

                <a href="https://el-gran-tesoro-del-craft.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" onClick={() => trackPixel('InitiateCheckout', {
                content_name: 'El Gran Tesoro del Craft',
                value: 19990,
                currency: 'ARS'
              })} className="group w-full bg-brand-gold hover:bg-brand-goldHover text-white font-bold px-6 py-4 rounded-xl transition-all hover:-translate-y-1 shadow-[0_8px_30px_rgba(184,137,79,0.4)] flex items-center justify-center gap-3 mb-4" data-id="element-164">
                  <SparklesIcon className="w-5 h-5" data-id="element-165" />
                  <span className="text-lg" data-id="element-166">COMPRAR AHORA</span>
                  <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" strokeWidth={2.5} data-id="element-167" />
                </a>

                <div className="flex flex-col gap-2 w-full" data-id="element-168">
                  <div className="flex items-center justify-center gap-2 text-brand-muted text-xs" data-id="element-169">
                    <ShieldCheckIcon className="w-4 h-4 text-brand-gold shrink-0" data-id="element-170" />
                    <span data-id="element-171">
                      Garantía 7 días: si no te gusta, te devolvemos el pago
                    </span>
                  </div>
                  <div className="flex items-center justify-center gap-2 text-brand-muted text-xs" data-id="element-172">
                    <LockIcon className="w-4 h-4 text-brand-gold shrink-0" data-id="element-173" />
                    <span data-id="element-174">Pago con Mercado Pago</span>
                  </div>
                  <div className="flex items-center justify-center gap-2 text-brand-muted text-xs" data-id="element-175">
                    <ZapIcon className="w-4 h-4 text-brand-gold shrink-0" data-id="element-176" />
                    <span data-id="element-177">Acceso inmediato</span>
                  </div>
                  <div className="flex items-center justify-center gap-2 text-brand-muted text-xs" data-id="element-178">
                    <MailIcon className="w-4 h-4 text-brand-gold shrink-0" data-id="element-179" />
                    <span data-id="element-180">Formato PDF vía mail</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Guarantee */}
        <FadeIn delay={0.2} className="mt-12 sm:mt-14 text-center max-w-2xl mx-auto" data-id="element-181">
          <div className="bg-white/5 border border-white/10 rounded-2xl px-6 sm:px-8 py-8" data-id="element-182">
            <ShieldCheckIcon className="w-12 h-12 sm:w-14 sm:h-14 text-brand-gold mx-auto mb-5" data-id="element-183" />
            <h3 className="text-xl sm:text-2xl font-black text-white mb-3" data-id="element-184">
              Garantía total de 7 días.
            </h3>
            <p className="text-white/60 leading-relaxed text-sm sm:text-base" data-id="element-185">
              Abrís el bundle. Revisás los 6 tomos, los bonos, las plantillas.
              Si en 7 días sentís que no cumple lo prometido, te devolvemos el
              100% sin preguntas, sin formularios y sin drama. Riesgo cero para
              vos.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}